// Presentation-only helpers. Shopify still supplies all filter values and counts.
class RegearSizeFilters extends HTMLElement {
  connectedCallback() {
    this.addEventListener('click', this.onClear);
  }
  disconnectedCallback() {
    this.removeEventListener('click', this.onClear);
  }
  onClear = (event) => {
    if (!event.target.closest('[data-size-clear]')) return;
    for (const input of this.querySelectorAll('input[type="checkbox"]')) input.checked = false;
    this.closest('facets-form-component').updateFilters();
  };
}
class RegearFilterSearch extends HTMLElement {
  connectedCallback() {
    this.addEventListener('input', this.onInput);
    this.addEventListener('change', this.stopChange);
  }
  disconnectedCallback() {
    this.removeEventListener('input', this.onInput);
    this.removeEventListener('change', this.stopChange);
  }
  stopChange = (event) => event.stopPropagation();
  onInput = (event) => {
    event.stopPropagation();
    const query = event.target.value.trim().toLocaleLowerCase();
    const scope = this.closest('facet-inputs-component');
    let matches = 0;
    scope.toggleAttribute('data-brand-searching', Boolean(query));
    for (const item of scope.querySelectorAll('.facets__inputs-list-item')) {
      const match = item.textContent.toLocaleLowerCase().includes(query);
      item.toggleAttribute('data-brand-no-match', Boolean(query) && !match);
      if (match) matches++;
    }
    this.querySelector('[data-search-empty]').hidden = matches > 0;
  };
}
if (!customElements.get('regear-size-filters')) customElements.define('regear-size-filters', RegearSizeFilters);
if (!customElements.get('regear-filter-search')) customElements.define('regear-filter-search', RegearFilterSearch);
